import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./core/appVersion";
import { AppErrorBoundary } from "./core/telemetry/AppErrorBoundary";
import { installClickTelemetry } from "./core/telemetry/clickTelemetry";
import { createTelemetryCaches } from "./core/telemetry/queryTelemetry";
import { reactRootErrorHandlers } from "./core/telemetry/reactErrorHandlers";
import { initTelemetry } from "./core/telemetry/telemetry";
import App from "./App.tsx";

// Start before rendering so startup crashes are reported.
initTelemetry();
installClickTelemetry();

// Enable dark mode
// document.documentElement.classList.add("dark");

// Create a query client with default options
const queryClient = new QueryClient({
  ...createTelemetryCaches(),
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30 * 1000, // 30 seconds
    },
    mutations: {
      retry: 0,
    },
  },
});

createRoot(document.getElementById("root")!, reactRootErrorHandlers).render(
  <StrictMode>
    <AppErrorBoundary scope="app">
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </AppErrorBoundary>
  </StrictMode>
);
